import { type FlashDeals } from '@vakantiesnl/types';
import dayjs from 'dayjs';

/** Filter out flashdeals which are before the expirationDate && the validFrom is after today */
export const filterInvalidFlashdeal = (flashDeal: FlashDeals.FlashDeal): boolean =>
	dayjs(flashDeal.flashDeal.validFrom, 'YYYY-MM-DD').isSameOrBefore(dayjs().startOf('d')) &&
	dayjs(flashDeal.flashDeal.expirationDate, 'YYYY-MM-DD').endOf('d').isSameOrAfter(dayjs().endOf('d'));
